import { useQuery } from '@apollo/client';
import { Col, Row } from 'antd';

import { USER_QUERY } from '../app/graphql/authQueries';
import routes from '../app/routes';
import { extractGraphqlEntity } from '../common/utils/graphqlUtils';
import ErrorBoundary from '../components/ErrorBoundary';
import { HeaderLogo } from '../components/Logo';
import { ThreeDotsSpinner } from '../components/data/Spinner';
import { BlockLink } from '../components/typography';
import { AccountDropdown } from './AccountDropdown';
import MainMenuTrigger from './MainMenuTrigger';
import { MainTopMenu } from './menus';
import { useMainMenuHeaderStyles } from './MainMenuHeader.styles';

const LogoCol = () => (
  <Col>
    <BlockLink to={routes.root}>
      <HeaderLogo size="lg" />
    </BlockLink>
  </Col>
);

export default function MainMenuHeader() {
  const { loading, data } = useQuery(USER_QUERY);
  const user = data && extractGraphqlEntity(data);
  const { styles } = useMainMenuHeaderStyles();

  return (
    <ErrorBoundary>
      <div className={styles.mainMenuHeader}>
        <Row align="middle" justify="space-between">
          <LogoCol />
          <Col>
            <Row align="middle">
              <Col>
                <MainTopMenu />
              </Col>
              <Col>
                <MainMenuTrigger />
              </Col>
              <Col>
                {loading ? (
                  <ThreeDotsSpinner />
                ) : (
                  <AccountDropdown user={user} />
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </ErrorBoundary>
  );
}
